module.exports = __webpack_public_path__ + "img/topic-ok.681facc9.png";